<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.389999940395356,0.9999999403953552C8.889999940395356,1.4999999403953552,8.989999940395355,2.479999940395355,9.539999940395354,3.529999940395355C9.539999940395354,3.529999940395355,4.379999940395355,7.539999940395355,4.379999940395355,7.539999940395355C2.8499999403953553,6.499999940395355,1.5199999403953552,6.0699999403953555,0.9999999403953552,6.589999940395355C0.9999999403953552,6.589999940395355,4.499999940395355,10.089999940395355,4.499999940395355,10.089999940395355C4.479999940395356,10.109999940395355,3.0999999403953553,12.889999940395356,3.0999999403953553,12.889999940395356C3.0999999403953553,12.889999940395356,5.899999940395356,11.489999940395355,5.899999940395356,11.489999940395355C5.899999940395356,11.489999940395355,9.399999940395356,14.989999940395355,9.399999940395356,14.989999940395355C9.929999940395355,14.459999940395356,9.499999940395355,13.129999940395356,8.449999940395355,11.609999940395355C8.449999940395355,11.609999940395355,12.469999940395356,6.449999940395355,12.469999940395356,6.449999940395355C13.509999940395355,6.999999940395355,14.479999940395356,7.099999940395355,14.979999940395356,6.589999940395355C14.979999940395356,6.589999940395355,9.389999940395356,0.9999999403953552,9.389999940395356,0.9999999403953552C9.389999940395356,0.9999999403953552,9.389999940395356,0.9999999403953552,9.389999940395356,0.9999999403953552Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Unpin',
} as DefineComponent
</script>
